import { memo } from "react";
import { WarehouseContactCardProps } from "./types";
import { useTranslate } from "helpers";
import { NoResults } from "ui/components/NoResults";
import { TableSearch } from "ui/components/Table/TableSearch";
import { WAREHOUSE_CONTACT_SEARCH_COLUMNS } from "./consts";

const WarehouseContactCard: React.FC<WarehouseContactCardProps> = (props) => {
  const { fleetWarehouseDetail } = props;

  const { t } = useTranslate();

  const contacts = fleetWarehouseDetail.contacts ?? [];

  return (
    <div className="space-y-3 mt-1">
      <div className="m-[-1px]">
        {contacts.length === 0 ? (
          <NoResults message={t("admin.fleet.warehouse.detail.contact.noresults")} />
        ) : (
          <TableSearch
            columns={WAREHOUSE_CONTACT_SEARCH_COLUMNS(t)}
            data={contacts}
            selectableRows={false}
            disablePagination={true}
            isLoading={false}
          />
        )}
      </div>
    </div>
  );
};

export default memo(WarehouseContactCard);
